/**
 * TipTap Custom Node: AuditLink
 *
 * Inline Chip/Badge der auf ein Audit verweist.
 * Klick navigiert zur Audit-ClipBox und zeigt die Audit-View.
 */

import { Node, mergeAttributes } from '@tiptap/core'

export interface AuditLinkOptions {
  onAuditClick?: (auditId: string) => void
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    auditLink: {
      insertAuditLink: (attrs: { auditId: string; label: string; potentiale?: string }) => ReturnType
    }
  }
}

export const AuditLinkNode = Node.create<AuditLinkOptions>({
  name: 'auditLink',
  group: 'block',
  atom: true,
  // draggable wird NICHT gesetzt — eigenes Drag-System in EmbedDragPlugin.ts

  addOptions() {
    return { onAuditClick: undefined }
  },

  addAttributes() {
    return {
      auditId: {
        default: null,
        parseHTML: el => el.getAttribute('data-audit-id'),
        renderHTML: attrs => ({ 'data-audit-id': attrs.auditId }),
      },
      label: {
        default: 'Audit',
        parseHTML: el => el.getAttribute('data-label'),
        renderHTML: attrs => ({ 'data-label': attrs.label }),
      },
      potentiale: {
        default: '',
        parseHTML: el => el.getAttribute('data-potentiale'),
        renderHTML: attrs => ({ 'data-potentiale': attrs.potentiale }),
      },
    }
  },

  parseHTML() {
    return [
      { tag: 'div[data-type="audit-link"]' },
      { tag: 'span[data-type="audit-link"]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'audit-link',
        class: 'audit-link-chip',
        contenteditable: 'false',
      }),
      HTMLAttributes['data-label'] ?? 'Audit',
    ]
  },

  addCommands() {
    return {
      insertAuditLink:
        attrs =>
        ({ commands }) => {
          return commands.insertContent({ type: this.name, attrs })
        },
    }
  },
})
